import * as ActiveStorage from '@rails/activestorage'
import '@hotwired/turbo-rails'
import './../../channels'

import 'chartkick/chart.js'

import $ from 'jquery';
import autocomplete from 'autocompleter'
import moment from 'moment';
import Cookies from 'js-cookie';
import './utils';

import * as bootstrap from 'bootstrap'
import Dropzone from 'dropzone';

ActiveStorage.start()

window.autocomplete = autocomplete
window.jQuery = $
window.$ = $
const jQuery = $

window.moment = moment
window.Cookies = Cookies

window.bootstrap = bootstrap

Dropzone.autoDiscover = false;
let initiated = false
window.init_captcha = (key) => {
    window.mtcaptchaConfig = {

        "sitekey": key,
        "customStyle": {
            "cardColor": "#2B3452",
            "cardShadowColor": "rgba(13,38,54,1)",
            "placeHolderColor": "#445C80",
            "inputTextColor": "#eeeeee",
            "invalidMsgTextColor": "#94312E",
            "inputBackgroundColor": "#121730",
            "inputBorderColor": {
                "byDefault": "#2B3452",
                "hover": "#1EC997"
            },
            "buttonIconColor": {
                "refresh": "#1EC997",
                "verify": "#1EC997",
                "success": "#41C47D",
                "fail": "#94312E",
                "audio": "#1EC997",
                "audiofocus": "#1EC997"
            }
        }
    };

    if (initiated !== true) {
        const mt_service = document.createElement('script');
        mt_service.async = true;
        mt_service.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mt_service);
        const mt_service2 = document.createElement('script');
        mt_service2.async = true;
        mt_service2.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mt_service2);
        initiated = true
    }
    try {
        window.mtcaptcha.remove()
        window.mtcaptcha.renderUI()
    } catch (e) {

    }


}


const init_typeahead = () => {

    $('.user-search-typeahead').each(function () {
        var input = $(this)[0];

        autocomplete({
            input: input,
            fetch: function (value, update) {
                return $.get('/users/search.json?q[username_or_firstname_or_lastname_or_email_i_cont_all]=' + value, function (data) {
                    update(data);
                });
            },
            onSelect: function (item) {
                input.value = item.value;
            }
        })
    })
}
window.init_typeahead = init_typeahead;

const init_titles = () => {

    // The `:not(.select2 *)` this used to carry excluded select2's generated
    // markup, which no longer exists.
    $('*[title]').each(function () {
        if ($(this).attr('title').length > 0) {

            $(this).attr('data-bs-toggle', 'tooltip')


            if ($(this).data('title-pos')) {
                var titlePos = $(this).data('title-pos');
            } else {
                var titlePos = 'top';
            }
            $(this).attr('data-bs-placement', titlePos)
            new bootstrap.Tooltip($(this))
        }
    });

    // SVG icons carry a <title> for accessibility, which we turn into a tooltip
    // on the icon itself. Scope this to SVGs — an unscoped $('title') also
    // matches the document <head><title> and removed it below, wiping the page
    // title on every load.
    $('svg > title').each(function () {
        const svg = $(this).parent()
        svg.attr('title', $(this).text())
        svg.attr('data-bs-toggle', 'tooltip')


        if (svg.data('title-pos')) {
            var titlePos = svg.data('title-pos');
        } else {
            var titlePos = 'top';
        }
        svg.attr('data-bs-placement', titlePos)
        $(this).remove()
        new bootstrap.Tooltip(svg)
    });

    /*var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    window.popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            template: $(popoverTriggerEl).closest('.seat-wrapper').find('.popover-wrapper').html(),
            boundary: '#seating_plan',
            offset: [0, 20],
            placement: 'top',
            content: '.',
            sanitize: false,
            trigger: 'hover'
        })
    })*/
}

document.addEventListener('turbo:load', () => {


    $('.alert a.close').on('click', function () {
        $(this).closest('.alert').addClass('remove').animate({
            height: 0
        }, 600).queue(function () {
            $(this).remove();
        });
    });

    if ($('.dropzone--default').length > 0) {
        const dropzoneMessage = $('.dropzone--default').data('message') || ''
        new Dropzone('.dropzone--default', {
            maxFilesize: 5,
            thumbnailWidth: 300,
            thumbnailHeight: 300,
            dictDefaultMessage: `<i class='fal fa-cloud-upload fa-2xl'></i><br/>${dropzoneMessage}`,
            uploadMultiple: false,
            acceptedFiles: 'image/*, .jpg, .png, .gif, .jpeg',
            success: function () {
                $('.cancel-upload-button').hide();
            }
        });
    }

    $('.btn-print').off('click').on('click', function () {
        var el = $(this).closest('td').find('.disabled-print-wrapper')
        var clone = el.clone().detach().appendTo('body');
        clone.removeClass('disabled-print-wrapper');
        clone.addClass('showOnPrint');
        setTimeout(function () {
            window.print();
            clone.remove();
        }, 200)
    });

    $('.poll-vote-item').on('click', function (e) {
        e.preventDefault();
    });

    $('table tr').each(function () {
        var row_href = $(this).find('.row-link').attr('href');
        if (typeof row_href !== 'undefined') {
            $(this).on('click', function (e) {
                if ($(e.target).is('td, span, img')) {
                    window.location = row_href;
                }
            });
        }
    });

    $('#search_form').on('submit', function (e) {
        e.preventDefault();

        $('.seat').removeClass("search-active");
        if ($('#search_input').val().length > 1) {
            $('.seat[data-username]').each(function () {
                if ($(this).data('username').toLowerCase().indexOf($('#search_input').val().toLowerCase()) >= 0) {
                    $(this).addClass("search-active");
                }
            });
        }
    });

    const dropdownElementList = document.querySelectorAll('.dropdown-menu--no-animation .dropdown-toggle')
    const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl, {
        popperConfig: {
            strategy: "fixed"
        }
    }))

    init_typeahead();
    init_titles();
})
